import { Helmet } from "react-helmet";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Collapse,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import DropZone from "../../../components/DropZone";
import CloseIcon from "../../../assets/images/plus-circle-fill.svg";
import PortfolioDetailCollapseList from "../../../components/workloadAndPerformance/WorkloadAndPerformanceDetailCollapseList";
import AttachFilesDialog from "../../../components/workloadAndPerformance/AttachFilesDialog";
import DefaultForm from "../../../components/workloadAndPerformance/DefaultForm";
import CustomForm from "../../../components/workloadAndPerformance/CustomForm";
import SimpleDialog from "../../../components/SimpleDialog";
import ConfirmDialog from "../../../components/ConfirmDialog";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { ReactComponent as PencilWhiteIcon } from "../../../icons/pencil-white.svg";
import { ReactComponent as PlusIcon } from "../../../icons/plus.svg";
import { ReactComponent as TrashIcon } from "../../../assets/images/portfolio/trash-alt.svg";
// import PdfIcon from "../../../assets/images/jpeg.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import fileBrowser from "../../../icons/file-browser.svg";
import cssVariables from "../../../theme/cssVariables";
import { useSelector, useDispatch } from "react-redux";
import workloadAndPerformanceService from "../../../services/workloadAndPerformance.service";
import { ReactComponent as PdfIcon } from "../../../assets/images/iconFile/pdf.svg";
import { ReactComponent as JpgIcon } from "../../../assets/images/iconFile/jpg.svg";
import { ReactComponent as PngIcon } from "../../../assets/images/iconFile/png.svg";
import { ReactComponent as NullIcon } from "../../../assets/images/iconFile/Null-File.svg";
import { useParams, useNavigate } from "react-router-dom";
import MessageDialog from "../../../components/inbox/MessageDialog";
import * as Util from "../../../services/global.service";

const PortfolioDetail = (props) => {
  const { t } = useTranslation();
  const portfolio = useSelector((state) => state.Portfolio);
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const [isDialogOpen, openDialog] = React.useState(false);
  const [isAddDialogOpen, openDialogAdd] = React.useState(false);
  const [isSuccessDialogOpen, openConfirmDialog] = React.useState(false);
  const [newForm, setForm] = React.useState(0);
  const [subTitle, setSubTitle] = React.useState("");
  const [createFormData, setCreateFormData] = React.useState({
    "rb_work_category": "",
    "rb_work_condition": "",
    "description": "",
    "name": "",
    "code": "",
    "remark": "",
  });
  const [errorText, seterrorText] = React.useState("");

  const handleOpenDialog = (event) => {
    openDialogAdd(true)
    setForm(1)
  };

  const [currentEditForm, setEditForm] = React.useState({ id: "", isManual: "" });
  const handleEditForm = () => {
    setEditForm({ id: dataDetail?.portfolio?.serial, isManual: dataDetail?.portfolio?.isManual })
    handleOpenDialog()
  }
  const handleCloseDialogs = () => {
    openDialogAdd(false);
    setEditForm({})
    setCreateFormData({
      ...createFormData, ...{
        rb_work_category: "",
        rb_work_condition: "",
        description: "",
        name: "",
        code: "",
        remark: "",
      }
    })
  };
  const handleFirstForm = (values) => {
    setSubTitle(values.subTitle)
    setCreateFormData({
      ...createFormData, ...{
        rb_work_category: values.workTypeSelected,
        rb_work_condition: values.subWorkTypeSelected,
        description: values.description,
        name: values.name,
        code: values.code,
        remark: "",
      }
    })
    if (newForm < 2)
      setForm(newForm + 1);
    else
      handleConfirmDialog()
  };
  const handleBackToDefaultForm = () => {
    if (newForm > 1)
      setForm(newForm - 1);
    else
      openDialogAdd(false);
  };

  const handleConfirmDialog = () => {
    openConfirmDialog(true)
    handleCloseDialogs()
  };
  const handleCreateForm = async (values, academic_unit) => {
    workloadAndPerformanceService.addList({ ...createFormData, value: values, remark: values.remark, academic_unit: academic_unit?.value }, currentEditForm?.id).then(
      (response) => {
        getDetails()
        handleConfirmDialog()
      },
    ).catch(() => {
      if (currentEditForm?.id !== undefined && currentEditForm?.id !== null && currentEditForm?.id !== "") {
        seterrorText('กรุณาแก้ไขรายการภาระงานและผลงาน')
      } else {
        seterrorText('กรุณาเพิ่มรายการภาระงานและผลงาน')
      }
      handleOpenFailedMessageDialog()
    })
    handleCloseDialogs()
  }

  let { portNo } = useParams();
  const [isAttachFilesDialogOpen, openAttachFilesDialog] = React.useState(false);
  const [dataDetail, openDaTaDetail] = React.useState({});
  const handleFilesDialog = () => {
    openAttachFilesDialog(true)
  }

  const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
  const handleOpenFailedMessageDialog = (value) => {
    setFailedMessageDialog(true);
  };
  const handleCloseFailedMessageDialog = (value) => {
    setFailedMessageDialog(false);
  };

  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);

  const handleConfirmDeleteDialog = (val) => {
    if (dataDetail?.portfolio?.isManual === true) {
      openConfirmDeleteDialog(val)
    }
  };
  const handleConfirmDeleteList = () => {
    workloadAndPerformanceService.DeleteList(portNo).then(
      (response) => {
        handleConfirmDeleteDialog(false)
        openSuccessDeleteDialog(true)
        // navigate('/app/workload-and-performance', { replace: false });
      },
    ).catch(() => {
      if (currentEditForm?.id !== undefined && currentEditForm?.id !== null && currentEditForm?.id !== "") {
        seterrorText('กรุณาลบรายการภาระงานและผลงาน')
      } else {
        seterrorText('กรุณาลบรายการภาระงานและผลงาน')
      }
      handleOpenFailedMessageDialog()
    })
  };
  const submit = () => {
    openSuccessDeleteDialog(false)
    navigate('/app/workload-and-performance', { replace: false });
  }
  const handleCloseDialog = () => {
    openDialog(false);
  };

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  function niceBytes(x) {
    let l = 0, n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) {
      n = n / 1024;
    }
    return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
  }

  const [fileList, setFileList] = React.useState([]);
  const handleGetFilesList = (val) => {
    getListFiles()
  }
  const handleRemoveFile = (val) => {
    workloadAndPerformanceService.deleteFiles(val.file.serial).then(
      (response) => {
        let odlFileList = JSON.parse(JSON.stringify(fileList))
        let newFileList = odlFileList.filter(file => file?.file?.serial !== val?.file?.serial)
        setFileList(newFileList)
      },
    );
  }
  useEffect(() => {
    getDetails()
    getListFiles()
  }, []);
  const getDetails = () => {
    workloadAndPerformanceService.getDetail(portNo).then(
      (response) => {
        if (response !== null && response !== undefined) {
          openDaTaDetail(response);
        } else {
          // navigate('/404', { replace: false });
        }
      },
    ).catch((err) => {
      // navigate('/404', { replace: false });
      console.log(err);
    })
  }
  const getListFiles = () => {
    workloadAndPerformanceService.getFiles(portNo).then(
      (response) => {
        setFileList(response)
      },
    );
  }
  const openInNewTab = (val) => {
    workloadAndPerformanceService.openFiles(val.file.serial).then(
      (response) => {
        // var myUrl = encodeURIComponent(response.data);
        // console.log(myUrl);
        // window.open(response.data, '_blank', 'noopener,noreferrer')
        const newWindow = window.open(response.data, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
      },
    );
  }

  const useStyles = makeStyles({
    root: {
      fontSize: "16px",
    },
    abbreviation: {
      color: "#5DA196",
      background: "white",
      border: "1px solid #5DA196",
      padding: "0 10px",
      borderRadius: "5px",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "18px!important",
    },
    expandableIcon: {
      background: "#F5F5F5",
      // padding: 3,
      width: '20px',
      height: '20px',
      borderRadius: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: '.3s',
      '&.active': {
        transform: "rotate(90deg)",
      }
    },
    outlineGrayBtn: {
      // border: '1px solid #DADADA!important',
      borderRadius: '5px!important',
      color: 'black',
      height: '30px'
    },
    fillWhite: {
      '& > path': {
        stroke: '#FFFFFF'
      },
      '& g > path': {
        stroke: '#FFFFFF'
      },
    },
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    statusBadge: {
      // maxWidth: "150px",
      borderRadius: "100px",
      padding: "8px 35px",
      margin: "0",
    },
    processBg: {
      background: "#E7EEF7",
    },
    processBgWhite: {
      background: "#ffffff",
      border: "1px solid #5387C6"
    },
    processText: {
      color: "#5387C6",
    },
    completedBg: {
      background: "rgba(93, 161, 150, 0.15);",
    },
    completedText: {
      color: "#5DA196",
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    }
  });
  const classes = useStyles();

  const formatData = (data, defaults) => {
    if (data !== null && data !== undefined && data !== "") {
      return data;
    }
    return defaults;
  }

  // mockup data
  const itemList = [
    { key: "รหัส", value: formatData(dataDetail?.portfolio?.code, "-") },
    { key: "ชื่อ", value: formatData(dataDetail?.portfolio?.nameTH, "-") },
    // { key: "ชื่อภาษาอังกฤษ", value: dataDetail?.portfolio?.nameEN },
    { key: "รายละเอียด", value: formatData(dataDetail?.portfolio?.descriptionTH, "-") },
    { key: "ปริมาณงานแผน", value: formatData(dataDetail?.quantity, "0") + ` ` + formatData(dataDetail?.unit, "") },
    { key: "ปริมาณงานจริง", value: formatData(dataDetail?.quantityActual, "0") + ` ` + formatData(dataDetail?.unit, "") },
    // { key: "ค่าตอบแทน", value: dataDetail?.quantityActual === true ? "ได้รับค่าตอบแทน" : "ไม่ได้รับค่าตอบแทน" },
  ];
  let itemListRender = []
  for (let i = 0; i < itemList.length; i++) {
    itemListRender.push(
      <Grid container spacing={4} sx={{ padding: "5px 0px" }}>
        <Grid item lg={2}>
          <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{itemList[i].key}</Typography>
        </Grid>
        <Grid item lg={10}>
          <Typography fontSize={18} lineHeight="25px" fontWeight="400">{itemList[i].value}</Typography>
        </Grid>
      </Grid>
    );
  }

  const disableDel = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "no-drop",
    opacity: "0.5",
    "& > button": {
      pointerEvents: "none"
    }
  }

  const notDisableDel = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }

  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };
  const navigate = useNavigate();
  const clickLink = (data) => {
    navigate(data, { replace: false });
  }
  return (
    <>
      <Helmet>
        <title>HOME | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={dataDetail?.is_owner === true ? styles.link : styles.end} onClick={dataDetail?.is_owner === true ? () => clickLink('/app/workload-and-performance') : null}>รายการภาระงานและผลงาน</span> / <span style={styles.end} >รายละเอียดภาระงานและผลงาน</span></Typography>
          </Grid>
          <Grid container>
            <Grid item md={12}>
              <Grid container item my={3} mt={0}>
                <Grid item md={6} pr={1}>
                  <Typography variant="h1" fontSize={36} color="#404349" lineHeight="39.6px" fontWeight="600">
                    {t("portfolio.label.myWorkloadDetail")}
                  </Typography>
                </Grid>
                {dataDetail?.is_owner === true ?
                  <Grid
                    item
                    md={6}
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <Box ml={1} sx={dataDetail?.portfolio?.isManual === true ? notDisableDel : disableDel}>
                      <Button
                        variant="contained"
                        color="red"
                        onClick={() => { handleConfirmDeleteDialog(true) }}
                      >
                        <Box
                          mr={1}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <TrashIcon class={`${classes.fillWhite}`} />
                        </Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          {/* {t("delete")} */}
                          ลบ
                        </Box>
                      </Button>
                    </Box>
                    <Box ml={1}>
                      <Button
                        variant="contained"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={handleEditForm}
                      >
                        <Box
                          mr={1}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <PencilWhiteIcon />
                        </Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          {/* {t("edit")} */}
                          แก้ไข
                        </Box>
                      </Button>
                    </Box>
                  </Grid>
                  : null
                }
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item lg={12} md={12}>
              <Card>
                <CardContent>
                  <Grid container spacing={5} padding={1}>
                    <Grid item lg={12}>
                      <Box display="flex" alignItems="center" width="100%">
                        <Box mr={3}>
                          <Typography className={classes.abbreviation}>
                            {formatData(dataDetail?.sourceAcronym, "-")}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            width: "10%",
                            minWidth: "100px",
                            wordWrap: "break-word",
                          }}
                        >
                          <Typography fontSize={20} lineHeight="22px" fontWeight="500">
                            {formatData(dataDetail?.portfolio?.code, "-")}
                          </Typography>
                        </Box>
                        <Box sx={{ width: "auto", maxWidth: "50%" }} mr={5}>
                          <Typography fontSize={20} lineHeight="22px" fontWeight="500">
                            {formatData(dataDetail?.portfolio?.nameTH, "-")}
                          </Typography>
                        </Box>
                        <Box sx={{ width: "auto" }} flexGrow="1" display="flex">
                          {dataDetail?.portfolio?.isEvaluated === true ?
                            <>
                              <CheckCircleIcon
                                style={{
                                  fill: cssVariables.color.primary,
                                  marginRight: 3,
                                }}
                              ></CheckCircleIcon>
                              <Typography
                                color={cssVariables.color.primary}
                                fontWeight="500"
                              >
                                ใช้เป็นภาระงาน
                              </Typography>
                            </>
                            : null}
                        </Box>
                        <Box textAlign="center">
                          <Typography pr={3} color={cssVariables.color.primary} fontWeight="400" color="#858585">
                            {Util.dateDayTimeFormat(dataDetail?.date)}
                          </Typography>
                        </Box>
                        <Box textAlign="center">
                          <Box
                            className={`${classes.statusBadge} ${classes.processBgWhite}`}
                            sx={{ padding: "7px 35px" }}
                          >
                            <Typography
                              className={classes.processText}
                              fontSize={16}
                              fontWeight="500"
                            >
                              {dataDetail?.portfolio?.isWork === true ? "ภาระงาน" : "ผลงาน"}
                            </Typography>
                          </Box>
                        </Box>
                        {formatData(dataDetail?.workStatus, false) !== false ?
                          <Box textAlign="center" sx={{ paddingLeft: "25px" }}>
                            <Box
                              className={`${classes.statusBadge} ${classes.processBg}`}
                            >
                              <Typography
                                className={classes.processText}
                                fontSize={16}
                                fontWeight="500"
                              >
                                {formatData(dataDetail?.workStatus, "-")}
                              </Typography>
                            </Box>
                          </Box>
                          : null}
                      </Box>
                    </Grid>
                    <Grid item lg={12} sx={{ paddingTop: "20px!important" }}>
                      <Divider />
                    </Grid>
                    <Grid
                      item
                      p={2}
                      lg={12}
                      sx={{ paddingTop: "20px!important" }}
                    >
                      {itemListRender}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          {/* end  portfoliio 10*/}
          {/* start portfoliio 20*/}
          <Grid container spacing={4} mt={1}>
            <Grid item lg={6}>
              <Grid container spacing={5}>
                <Grid item lg={12}>
                  <Card className="min-height-card">
                    <CardContent>
                      {Object.keys(dataDetail).length > 0 ?
                        <PortfolioDetailCollapseList data={dataDetail}></PortfolioDetailCollapseList>
                        : null}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={6}>
              <Grid container spacing={1}>
                <Grid item lg={12}>
                  <Card className="min-height-card">
                    <CardContent>
                      {/* header */}
                      <Grid container pt={0} pb={2}>
                        <Grid item md={6} pr={1}>
                          <Typography fontSize={20} fontWeight="500" sx={{ paddingTop: "10px", paddingBottom: "10px" }}>
                            {/* {t("portfolio.label.myWorkloadDetail")} */}
                            เอกสารแนบ ({fileList.length})
                          </Typography>
                        </Grid>
                        {dataDetail?.is_owner === true ?
                          <Grid
                            item
                            md={6}
                            display="flex"
                            alignItems="center"
                            justifyContent="flex-end"
                          >
                            <Box ml={1} p={0}>
                              <Button size="small" variant="contained" color="primary" className={classes.outlineGrayBtn} onClick={handleFilesDialog}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                >
                                  <PlusIcon className={classes.plusSvg} />
                                  {/* <Typography sx={{ marginLeft: "3px", color: 'black!important' }}> */}
                                  {/* {t("addfile")} */}
                                  <Box style={{ marginLeft: "3px", fontSize: "15px" }}>
                                    เพิ่ม
                                  </Box>
                                  {/* </Typography> */}
                                </Box>
                              </Button>
                            </Box>
                          </Grid>
                          : null
                        }
                      </Grid>
                      {/* end header */}
                      {/* content */}
                      {
                        fileList.length > 0 ?
                          [...fileList].map(item => {
                            return (
                              <Grid container mt={1}>
                                <Grid item xs={12}>
                                  <Paper elevation={2}>
                                    <Grid container item p={2}>
                                      <Grid
                                        item
                                        display="flex"
                                        alignItems="center"
                                        md={1}
                                      >
                                        <Box ml={1} p={0} sx={{ width: "33px", height: "33px" }}>
                                          {item.file.mimetype === "application/pdf" ?
                                            <PdfIcon /> :
                                            item.file.mimetype === "image/png" ?
                                              <PngIcon /> :
                                              item.file.mimetype === "image/jpeg" ?
                                                <JpgIcon /> : <NullIcon />
                                          }
                                        </Box>
                                      </Grid>
                                      <Grid item md={6} pr={1} onClick={() => openInNewTab(item)}>
                                        <Grid container item p={0}>
                                          <Grid item pr={1}>
                                            <Typography variant="h5" sx={{ cursor: "pointer" }}>
                                              {item.file.name}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                        <Grid container item p={0}>
                                          <Grid item pr={1}>
                                            <Typography variant="sub_label">
                                              {niceBytes(item.file.size)}
                                            </Typography>
                                            <Typography variant="sub_label" pl={1} pr={1}>
                                              |
                                            </Typography>
                                            <Typography variant="sub_label">
                                              {Util.dateDayTimeFormat(item.file.createdAt)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      {dataDetail?.is_owner === true ?
                                        <Grid
                                          item
                                          display="flex"
                                          alignItems="center"
                                          flexDirection="row-reverse"
                                          md
                                        >
                                          <Box ml={1} p={0} className="clickable" onClick={() => handleRemoveFile(item)}>
                                            <TrashIcon />
                                          </Box>
                                        </Grid>
                                        : null
                                      }
                                    </Grid>
                                  </Paper>
                                </Grid>
                              </Grid>
                            )
                          }
                          ) :
                          dataDetail?.is_owner === true ?
                            (<Grid container spacing={4} mt={6}>
                              <Grid item lg={12} md={12}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  flexDirection="column"
                                  p={1}
                                >
                                  <Box>
                                    <img src={fileBrowser} alt="browser" />
                                  </Box>
                                  <Box>
                                    <Typography variant="sub_label">{t("portfolio.label.nodata")} หากต้องการเพิ่มข้อมูลให้</Typography>
                                  </Box>
                                  <Box>
                                    <Typography
                                      classes={{ root: classes.clickable }}
                                      style={{ color: "#5DA196", fontWeight: "500", textDecoration: "underline" }}
                                      onClick={handleFilesDialog}
                                    >
                                      {/* {t("portfolio.label.clickhere")} */}
                                      คลิกที่นี่
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>)
                            :
                            (<Grid container spacing={4} mt={6}>
                              <Grid item lg={12} md={12}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  flexDirection="column"
                                  p={1}
                                >
                                  <Box>
                                    <img src={fileBrowser} alt="browser" />
                                  </Box>
                                  <Box>
                                    <Typography variant="sub_label">{t("portfolio.label.nodata")}</Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>)
                      }
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Dialog
            onBackdropClick={() => { return false }}
            open={isDialogOpen}
            onClose={handleCloseDialog}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth="xl"
          >
            <DialogTitle id="form-add-dialog-title" fontSize={24}>
              {t("portfolio.label.add.workLoad")}
            </DialogTitle>
            <DialogContent px={3}>
              <Grid container>
                <Grid item>
                  <Typography variant="h4">รายละเอียดงานสอน</Typography>
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item>
                  <Typography variant="subtitle1">รหัสวิชา</Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item md>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item>
                  <Typography variant="subtitle1">ชื่อวิชา</Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item md>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item>
                  <Typography variant="subtitle1">ประเภทงานสอน</Typography>
                </Grid>
              </Grid>
              <Grid container mt={1}>
                <Grid item md>
                  <Select
                    native
                    id="demo-simple-select"
                    inputlabelprops={{ shrink: false }}
                    variant="outlined"
                    size="small"
                    fullWidth={true}
                    maxWidth="xl"
                  >
                    <option value={10}>
                      ชั่วโมงสอนในสถาบัน (ภาคปกติ ภาคพิเศษ ฝึกอบรบนับเครดิต)
                    </option>
                    <option value={20}>
                      ชั่วโมงสอนในสถาบัน (ภาคปกติ ภาคพิเศษ ฝึกอบรบนับเครดิต)
                    </option>
                    <option value={30}>
                      ชั่วโมงสอนในสถาบัน (ภาคปกติ ภาคพิเศษ ฝึกอบรบนับเครดิต)
                    </option>
                  </Select>
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item>
                  <Typography variant="subtitle1">รายละเอียดวิชา</Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item md>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    multiline
                    rows={6}
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item md={6} xs={12} pr={1}>
                  <Typography variant="subtitle1">ชื่อหลักสูตร</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item md={6} xs={12} pl={1}>
                  <Typography variant="subtitle1">คณะ</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item md={6} xs={12} pr={1}>
                  <Typography variant="subtitle1">ประเภทงานสอน</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item md={6} xs={12} pl={1}>
                  <Typography variant="subtitle1">ภาค</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item md={6} xs={12} pr={1}>
                  <Typography variant="subtitle1">ประเภทงานสอน</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item md={6} xs={12} pl={1}>
                  <Typography variant="subtitle1">ภาค</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item md={6} xs={12} pr={1}>
                  <Typography variant="subtitle1">ประเภทงานสอน</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item md={6} xs={12} pl={1}>
                  <Typography variant="subtitle1">ภาค</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item md={6} xs={12} pr={1}>
                  <Typography variant="subtitle1">ประเภทงานสอน</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item md={6} xs={12} pl={1}>
                  <Typography variant="subtitle1">ภาค</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item md={6} xs={12} pr={1}>
                  <Typography variant="subtitle1">ประเภทงานสอน</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item md={6} xs={12} pl={1}>
                  <Typography variant="subtitle1">ภาค</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item md={6} xs={12} pr={1}>
                  <Typography variant="subtitle1">ประเภทงานสอน</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item md={6} xs={12} pl={1}>
                  <Typography variant="subtitle1">ภาค</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item>
                  <Typography variant="subtitle1">หมายเหตุ</Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item md>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    type="email"
                    fullWidth
                    multiline
                    rows={6}
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid container mt={2}>
                <Grid item>
                  <Typography variant="subtitle1">แนบไฟล์</Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item md>
                  <DropZone></DropZone>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <div classes="mt-3">
                <Button onClick={handleCloseDialog} color="primary">
                  ยกเลิก
                </Button>
                <Button
                  onClick={handleCloseDialog}
                  color="primary"
                  variant="contained"
                >
                  เพิ่ม
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        </Container>
        <Dialog onBackdropClick={() => { return false }} open={isAddDialogOpen} onClose={handleCloseDialogs} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '10px' } }}>
          <DialogTitle id="form-add-dialog-title" fontSize={24}>
            {dataDetail?.rbpa}
            <Box sx={{ position: "absolute", right: 0, margin: "30px 20px 0  0", top: 0 }} className="clickable" trash={true} onClick={handleCloseDialogs}><img src={CloseIcon} alt="browser" /></Box>
          </DialogTitle>
          <DialogContent px={0} pb={0}>
            <Divider />
            {
              newForm === 1 ?
                <DefaultForm close={handleCloseDialogs} submit={handleFirstForm} item={currentEditForm} data={createFormData}></DefaultForm>
                : <CustomForm close={handleBackToDefaultForm} subTitle={subTitle} serial={createFormData.rb_work_condition} submit={handleCreateForm} item={currentEditForm}></CustomForm>
            }
          </DialogContent>
        </Dialog>
        <SimpleDialog open={isSuccessDialogOpen} setValue={openConfirmDialog} text="เพิ่มรายการภาระงานและผลงาน" />
        <ConfirmDialog open={isConfirmDeleteDialogOpen} doConfirm={handleConfirmDeleteList} trash={true} setValue={handleConfirmDeleteDialog} title="ยืนยันการลบรายการภาระงานและผลงาน" text="ต้องการยืนยันการลบรายการภาระงานและผลงานหรือไม่ ?" />
        <AttachFilesDialog open={isAttachFilesDialogOpen} setValue={openAttachFilesDialog} submitFiles={handleGetFilesList} value={fileList}></AttachFilesDialog>
        <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={submit} text="การลบรายการภาระงานและผลงาน" />
        <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title="ดำเนินการไม่สำเร็จ" text={errorText + " \nใหม่อีกครั้ง"} />
      </Box>
    </>
  );
};
export default PortfolioDetail;
